/**
 * Must match webpack.prod.config.js for all environment variables
 */
export const APPENV = {
    mock_server: process.env.REACT_APP_MOCK_SERVER === "true",
    dev_server: process.env.REACT_APP_DEV_SERVER === "true",
    endpoints_stage: process.env.REACT_APP_ENDPOINTS_STAGE,
};
